export default "/images/vendor/flag-icon-css/flags/1x1/fk.svg?b12459dbb66471a9875440a6f03bf6c2";